export default __webpack_public_path__ + "static/media/3.39242cb1.png";